module.exports = __webpack_public_path__ + "img/gateway.7c59047d.png";